import css from './aio.less';
import React from "react";
import cn from 'classnames';
import "react-datepicker/dist/react-datepicker.css";
import icons from '../../../markons/markons';
import type {ClassValue} from '../../helpers/react-helpers'
import TimePicker2 from '../TimerPicker2';
import {useUuid} from "../../helpers/react-hooks";
import AioIcon from "./AioIcon";
import AioLabel from './AioLabel'

interface Props extends Pick<React.ComponentProps<typeof TimePicker2>, 'value' | 'onChange' | 'disabled' | 'militaryTime' | 'testId'> {
    id?: string
    width?: number | string
    minWidth?: number | string
    maxWidth?: number | string
    label: string
    className?: ClassValue
    inline?: boolean
    required?: boolean
}

export default function AioTimePicker({id, width, minWidth, maxWidth, label, className, disabled, testId, inline, required, ...inputProps}: Props) {
    const inputId = useUuid(id);

    return (
        <div className={cn(css.wrapper, css.hasIcon, className, !!disabled && css.disabled, !!inline && css.inline)}
             style={{width, minWidth, maxWidth}}>
            <TimePicker2 id={inputId} className={cn(css.text)} disabled={disabled} testId={testId} {...inputProps}/>
            <AioIcon name={icons.faClock}/>
            <AioLabel htmlFor={inputId} className={css.label} required={required}>{label}</AioLabel>
        </div>
    )
}
